module.exports = {
  props: ['loading'],
  template:`
    <section v-if="loading" class="loading">
      <div class="loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"/>
        </svg>
      </div>
    </section>
  `
}
